export const ActivityMenu = {
  DownloadActivity: { name: 'downloadActivity', text: "Download Members' Activity", icon: 'download' },
  DownloadActivityInProgress: {
    name: 'downloadActivityInProgress',
    text: "Download Members' Activity (In Progress)",
    icon: 'download',
    disabled: true
  }
};
